"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const constants_1 = require("../../../constants");
const utils_1 = require("@sentry/utils");
exports.insertAd = ({ el, log, step: { ad, adjacentInsertionPosition }, parentTimestamp, }) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const tagJsx = react_1.default.createElement("code", null,
        "<",
        el.tagName.toLowerCase(),
        " />");
    const newParentTs = parentTimestamp || new Date();
    const adjacentMeta = constants_1.CONVERSION_STEP_FIELD_META.adjacentInsertionPosition.options.find(opt => {
        return opt.value === adjacentInsertionPosition;
    });
    log('debug', {
        message: (react_1.default.createElement(react_1.default.Fragment, null,
            "Inserting ad into ",
            tagJsx,
            " (",
            adjacentMeta && adjacentMeta.label,
            ")...")),
        parentTimestamp: newParentTs,
        previewHtml: (_a = el) === null || _a === void 0 ? void 0 : _a.outerHTML,
    });
    if (!ad || !ad.html) {
        log('error', {
            message: react_1.default.createElement(react_1.default.Fragment, null,
                "Skipping step because no ad",
                !!ad && ' html',
                " found..."),
            parentTimestamp: newParentTs,
        });
        return el;
    }
    if (!ad) {
        log('error', {
            message: react_1.default.createElement(react_1.default.Fragment, null, "Skipping step because no ad found..."),
            parentTimestamp: newParentTs,
        });
        return el;
    }
    //    ||
    //         adjacentInsertionPosition === 'afterend'
    //         ? !!el.parentElement
    //         : true
    if (!el.parentElement && adjacentInsertionPosition === 'beforebegin') {
        try {
            el.before(ad.html);
        }
        catch (e) {
            log('error', {
                message: (react_1.default.createElement(react_1.default.Fragment, null, "Failed to insert ad before element that has no parent. Are you using Google Chrome?")),
                parentTimestamp: newParentTs,
            });
            utils_1.logger.error(e);
        }
    }
    else if (!el.parentElement && adjacentInsertionPosition === 'afterend') {
        try {
            el.after(ad.html);
        }
        catch (e) {
            log('error', {
                message: (react_1.default.createElement(react_1.default.Fragment, null, "Failed to insert ad after element that has no parent. Are you using Google Chrome?")),
                parentTimestamp: newParentTs,
            });
            utils_1.logger.error(e);
        }
    }
    else {
        try {
            el.insertAdjacentHTML(adjacentInsertionPosition, ad.html);
        }
        catch (e) {
            log('error', {
                message: (react_1.default.createElement(react_1.default.Fragment, null, "Failed to insert ad. Are you using Google Chrome and is this valid HTML?")),
                parentTimestamp: newParentTs,
            });
            utils_1.logger.error(e);
        }
    }
    log('success', {
        message: (react_1.default.createElement("span", { style: { verticalAlign: 'middle' } }, "Ad successfully inserted")),
        parentTimestamp: newParentTs,
        plainTextMessage: 'Screenshot succesfully taken.',
    });
    return el;
});
//# sourceMappingURL=insertAd.js.map